/* eslint-disable function-paren-newline */
import { useEvents } from '@events/EventsProvider';
import { useEffect } from 'react';
import useSessionStorage from './useSessionStorage';

type EventProperties = {
  validation?: boolean;
  flagKey: string;
  variant: string | null;
};

export default function useSendAmplitudeExposureV2({
  flagKey,
  variant,
  validation,
}: EventProperties) {
  const { amplitude } = useEvents();
  const { getItem, setItem } = useSessionStorage();
  const hasBeenExposedBefore = getItem(`${flagKey}-exposed`);

  useEffect(() => {
    if (validation && variant && amplitude && !hasBeenExposedBefore) {
      amplitude
        .track(
          {
            event_type: '$exposure',
          },
          {
            flag_key: flagKey,
            variant,
          },
        )
        .promise.then(() => setItem(`${flagKey}-exposed`, 'true'))
        .catch();
    }
  }, [amplitude, flagKey, hasBeenExposedBefore, setItem, variant, validation]);
}

useSendAmplitudeExposureV2.defaultProps = {
  validation: true,
};
